import React, { useEffect, useState } from "react";
import Header from "../../component/layout/Header";
import Footer from "../../component/layout/Footer";
import Page from "../../component/utility/Page";
import DataTable from "react-data-table-component";
import axios from "axios";
import { mainurl } from "../../Mainurl";
import { custTableStyles } from "../../style/color";
import { Row, Col, Card, CardHeader, CardBody, Form, Input, Label, Button, } from 'reactstrap';
import { notification } from '../../component/hocs/notification';

const LivestockReport = () => {
  const [tableData, setTableData] = useState([]);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [stateOpt, setStateOpt] = useState('');
  const [stateName, setStateName] = useState('');

  useEffect(() => {
    get_state_list();
  }, []);

  const get_state_list = () => {
    let postData = [{ user_id: sessionStorage.getItem('user_id') }];

    axios({
      method: 'post',
      url: mainurl + 'Master/get_state_list2',
      data: postData,
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (response) {
        console.log("response", response.data);
        let list = response.data.map((row) => {
          return <option value={row.state_code}>{row.state_name}</option>
        });
        setStateOpt(list);
      })
      .catch(() => {
        notification({
          message: "State not found!",
          type: 'error'
        })();
      });
  }

  const fetchReport = async (e) => {
    e.preventDefault();
    setTableData('');
    try {
      const payload = [{
        org_id: sessionStorage.getItem('org_id'),
        user_id: sessionStorage.getItem('user_id'),
        date_from: fromDate,
        date_to: toDate,
        state_id: stateName
      }];

      const res = await axios.post(
        `${mainurl}Activity/rpt_outcome_liv`,
        payload
      );

      if (res.data) {
        setTableData(res.data || []);
      }else{
        notification({ message: "No Data Found", type: "warn" })();
      }

    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    { name: "Activity", selector: row => row.activity_desc },
    { name: "Animal Count", selector: row => row.animal_count },
    { name: "Medicine Dose", selector: row => row.medicine_dose },
    { name: "Medicine Name", selector: row => row.medicine_name }
  ];

  return (
    <>
      <Header />
      <Page title="Livestock Report" breadcrumbs='Home / Livestock Report'>
        <Row className='p-3'>
          <Col xs={12}>
            <Card className='mb-3' color="primary" outline>
              <CardBody>
                <Form onSubmit={fetchReport}>
                  <Row>
                    <Col md={2} className="mb-2">
                      <Label for="month">From Date</Label>
                      <Input type="date" name="month" bsSize="sm" placeholder="From date" onChange={(e) => setFromDate(e.target.value)} required />
                    </Col>
                    <Col md={2} className="mb-2">
                      <Label for="month">To Date</Label>
                      <Input type="date" name="month" bsSize="sm" placeholder="To Date" onChange={(e) => setToDate(e.target.value)} required />
                    </Col>
                    <Col md={2} className="mb-2">
                      <Label for="month">State</Label>
                      <Input
                        type="select"
                        bsSize="sm"
                        value={stateName}
                        onChange={(e) => setStateName(e.target.value)}
                        required
                      >
                        <option value="">--Select State--</option>
                        {stateOpt}

                      </Input>
                    </Col>
                    <Col md={2} className="mb-2">
                      <Button className='text-white mt-4' color='primary' size="sm" block> Search </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
            <Card className='' color="primary" outline>
              <CardHeader>Livestock Report <small className='text-muted'> </small></CardHeader>
              <CardBody>
                <DataTable
                  columns={columns}
                  data={tableData}
                  pagination
                  customStyles={custTableStyles}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>

      </Page>
      <Footer />
    </>
  );
};

export default LivestockReport;
